"use client";

import { useEffect } from "react";
import { setSessionRecordingRouteBlocked } from "@/features/analytics/lib/session-recording-control";

/**
 * Blocks session replay while it is mounted. Used on the auth routes, where a
 * recording only captures the credentials flow and the sign-with-token link.
 *
 * Releasing the block does not by itself resume recording — cookie consent
 * still has to allow it, see `session-recording-control`.
 */
export function SessionRecordingGuard() {
  useEffect(() => {
    setSessionRecordingRouteBlocked(true);

    return () => {
      setSessionRecordingRouteBlocked(false);
    };
  }, []);

  return null;
}
